import { CaseReducer, PayloadAction, createSlice } from '@reduxjs/toolkit';

import { get } from 'api/requests';

import { loading } from 'store/common';

import { IReducer, AppThunk } from 'store/types';
import { IDefect } from 'pages/ApartmentStatus/types';

interface DefectsState {
  defects: IDefect[];
  loading: boolean;
}

const initialState: DefectsState = {
  defects: [],
  loading: false,
};

const reset: IReducer<DefectsState, DefectsState> = () => initialState;

const setDefects: CaseReducer<DefectsState, PayloadAction<IDefect[]>> = (state, action) => {
  state.defects = action.payload;
};

export const defectsSlice = createSlice({
  name: 'defects', // 'apartmentStatus/Modal/defects',
  initialState,
  reducers: {
    loading: loading as IReducer<DefectsState, boolean>,
    setDefects,
    reset,
  },
});

export const { loading: setLoading, setDefects: setDefectsData } = defectsSlice.actions;

export const getDefects =
  (cardId: number): AppThunk =>
  dispatch => {
    dispatch(setLoading(true));

    // TODO Передаваемый параметр передавался ли?
    get<IssuesResponce>('/api/issues/', { placement: cardId })
      .then(({ data }) => {
        const { results } = data;
        dispatch(setDefectsData(results));
      })
      .finally(() => dispatch(setLoading(false)));
  };

type IssuesResponce = {
  count: number;
  next: string;
  previous: null | string;
  results: IDefect[];
};
